<template>
    <div class="stream-content">
        <textarea class="form-text stream-content__value" v-model="editableContent"></textarea>

        <div class="stream-content__save">
            <button class="btn btn-primary" @click.prevent="updateContent">Сохранить контент</button>
            <transition name="fade-out">
                <div v-if="saveAnimation">Сохранено..</div>
            </transition>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "StreamContent",
    data() {
        return {
            editableContent: '',
            saveAnimation: false,
        };
    },
    computed: {
        ...mapState({
            stream: state => state.planUrl.selectedStream,
        }),
    },
    mounted() {
        this.resetContent();
    },
    watch: {
        stream() {
            this.resetContent();
        },
    },
    methods: {
        resetContent() {
            this.editableContent = this.stream.content;
        },
        updateContent() {
            if (this.isChanged()) {
                this.$store.dispatch('updatePlanUrlStream', {
                    streamId: this.stream.id,
                    field: 'content',
                    value: this.editableContent,
                }).then(r => {
                    this.saveAnimation = true;
                    setTimeout(() => this.saveAnimation = false, 2000);
                });
            }
        },
        isChanged() {
            return this.editableContent !== this.stream.content;
        },
    }
}
</script>

<style lang="scss">
.stream-content__value {
    width: 100%;
    margin: 0 0 10px;
}

.stream-content__save {
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #421D57;

    .btn {
        margin-right: 15px;
    }
}

.fade-out-leave-active {
    transition: opacity .5s ease;
}

.fade-out-leave-to {
    opacity: 0;
}
</style>
